import { default as config } from "common/config/config";
import i18next from "i18next";
import { initReactI18next } from "react-i18next";
import { es } from "./locales/es/es";
import LanguageDetectorPlugin from "./plugins/LanguageDetectorPlugin";

export const defaultNS = "translation";

//To add a new language, add it to the resources object and in the `getDefaultLocale`
export const resources = {
    es,
} as const;

export const i18nextInitializationPromise = i18next
    .use(initReactI18next)
    .use(LanguageDetectorPlugin)
    .init({
        /**
         * If you want to detect language from browser, remove this line
         * and the language will be detected from browser with the LanguageDetectorPlugin
         */
        lng: config.defaultLocale,
        fallbackLng: false,
        resources,
        debug: process.env.NODE_ENV === "development",
        interpolation: {
            escapeValue: false, // not needed for react as it escapes by default
        },
        returnNull: false,
    });

export default i18next;
